export default "BOOKING_STEPS_MODULE";
